/**
 * PrimeReact TabView calls tabHeader.scrollIntoView({ block: 'nearest' }) from
 * updateScrollBar() whenever the active tab updates. That scrolls every ancestor
 * scrollport including the window, so long pages jump ~400px to bring an
 * off-screen tab <li> into view — even when the tab strip has no horizontal overflow.
 *
 * Why not tabindex={-1}? Tabindex only affects focus/tabbing. The jump comes from
 * JS calling scrollIntoView on the <li> ref — not from focus — so changing tabindex
 * on the nav link or tab headers does not stop that scroll.
 *
 * For tab headers inside .p-tabview-nav we only adjust horizontal scroll on
 * .p-tabview-nav-content and skip the native scrollIntoView (no vertical window scroll).
 */
let installed = false;

function scrollTabHeaderWithinNav(
  navContent: HTMLElement,
  tabLi: HTMLElement
): void {
  const ncRect = navContent.getBoundingClientRect();
  const tabRect = tabLi.getBoundingClientRect();
  if (tabRect.left < ncRect.left) {
    navContent.scrollLeft += tabRect.left - ncRect.left;
  } else if (tabRect.right > ncRect.right) {
    navContent.scrollLeft += tabRect.right - ncRect.right;
  }
}

export function installPrimeTabViewNavScrollFix(): void {
  if (installed || typeof Element === 'undefined') {
    return;
  }
  installed = true;
  const orig = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function (
    this: Element,
    ...args: Parameters<typeof orig>
  ) {
    const el = this;
    const parentNav = el.parentElement;
    if (
      el.tagName === 'LI' &&
      parentNav?.classList.contains('p-tabview-nav')
    ) {
      const navContent = el.closest('.p-tabview-nav-content');
      if (navContent instanceof HTMLElement) {
        scrollTabHeaderWithinNav(navContent, el as HTMLElement);
        return;
      }
    }
    return orig.apply(el, args as never);
  };
}
